export const darkTheme = {
  colors: {
    background: "#1A1B20",
    accent: "#00B091",
    primary: "#293d56",
    primary_100: "#00527A",
    secondary: "#a3d0f5",
    darkBlue: "#1B263B",
    lightGrey: "#666666",
    mediumGrey: "#868686",
    darkGrey: "#979A9D",
    borderColor: "#45464B",
    inputBorderMedium: "#666666",
    inputBorder: "#45464B",
    chartGrid: "#45464B",
    text: "#ffffff",
    textSecondary: "#e7e7e7",
    iconSecondary: "#e7e7e7",
    iconHover: "#60a5fa",
    placeholder: "#93969a",
    select: "#263a54",
    white: "#ffffff",
    scrollbar: "#45464B",
    scrollbarHover: "#666666",
    menuBorder: "#45464B",
    menuBackground: "#25262d",
    menuIcon: "#fff9",
    logo: "#a3d0f5",
    logoAccent: "#4294c9",
    treeNodeHover: "#45464B",
    toggleIcon: "#b1b1b1",
    chip: "#45464B",
    button: "#00527A",
    buttonHover: "#293d56",
    buttonText: "#ffffff",
    stepDot: "#60d8fa80",
    pipeStroke: "#5A5F65",
    casingStroke: "#D9D9D9",
    chartHatch: "#6c757d",
    stageBadge: "#31353C",
  },
  spacing: {
    small: "10px",
    medium: "20px",
    large: "40px",
    max: "60px",
  },
  padding: {
    small: "10px",
    medium: "20px",
    large: "40px",
    button: "10px 20px",
    body: "20px",
    container: "30px",
  },
  shadow: {
    small: "0 0 6px rgba(0, 0, 0, 0.05)",
    medium: "0 0 6px rgba(0, 0, 0, 0.1)",
    large: "0 0 6px rgba(0, 0, 0, 0.12)",
  },
  borderRadius: {
    small: "6px",
    medium: "20px",
    large: "30px",
  },
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "1.3rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: 600,
    },
    body: {
      fontSize: "0.9rem",
      fontWeight: 400,
    },
    medium: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    small: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
};
